import { Box, Group } from "@mantine/core";
import { useOrderListFilter } from "../../contexts/OrderListFilterContext";
import hasActiveFilters from "../../utils/hasActiveFilters";
import BooleanFilter from "./components/BooleanFilter";
import ArrayStringFilter from "./components/ArrayStringFilter";
import DateRangeFilter from "./components/DateRangeFilter";

const FiltersDescription = () => {
  const { getAllFilters } = useOrderListFilter();
  const filters = getAllFilters();

  if (!hasActiveFilters(filters)) {
    return null;
  }

  const {
    isArchived,
    references,
    clinicCodes,
    doctors,
    providers,
    statuses,
    createdAt,
    deliveryDate,
    lastShippingDate,
  } = filters;

  return (
    <Box
      style={{
        padding: "8px 12px",
        border: "1px solid #e9ecef",
        borderRadius: "4px",
        fontSize: "14px",
        color: "#6c757d",
      }}
    >
      <Group gap="sm">
        <BooleanFilter name="isArchived" value={isArchived} />
        <ArrayStringFilter name="reference" value={references} />
        <ArrayStringFilter name="clinic code" value={clinicCodes} />
        <ArrayStringFilter name="doctor name" value={doctors} />
        <ArrayStringFilter name="provider" value={providers} />
        <ArrayStringFilter name="status" value={statuses} />
        <DateRangeFilter name="created at" value={createdAt} />
        <DateRangeFilter name="delivery date" value={deliveryDate} />
        <DateRangeFilter name="last shipping date" value={lastShippingDate} />
      </Group>
    </Box>
  );
};

export default FiltersDescription;
